import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/favicon/web-app-manifest-192x192.png")